import styled from 'styled-components'

export const Container = styled.div`
  ${props => props.theme.css.container};
  margin-bottom: 24px;

  h1 {
    ${props => props.theme.css.heading2};
    padding: 15px 0;
    color: ${props => props.theme.palette.primary.alphaDark};
  }
`
